angular.module('satv.playlist.pitch')

.controller('PitchModalCtrl', ['$scope', 'Pitch', '$state', function($scope, Pitch, $state) {
    $scope.isLoading = true;

    Pitch.query({
        playlist: $scope.playlist.id
    }, function(r) {
        if (r.length > 0) {
            Pitch.get({
                hash: r[0].hash
            }, function(pitch) {
                $scope.pitch = pitch;
                $scope.isLoading = false;
            });
        } else {
            $scope.isLoading = false;
        }
    });

    $scope.getUrl = function(pitch) {
        return $state.href('pitchLanding', { hash: pitch.hash }, {absolute: true});
    };

    $scope.getEmails = function(pitch) {
        if (pitch &&
            pitch.recipients &&
            pitch.recipients.length > 0
        ) {
            return pitch.recipients.map(function(user) {
                return user.email;
            });
        }
    };

}]);



// WEBPACK FOOTER //
// ./vendor/sonyatv/playlistpitchclientbundle/Resources/js/angular/controllers/PitchModalCtrl.js